import './scss/index.scss';
import { dcFactory } from 'dc';
import SearchBarComponent from './js/search-bar.component';

dcFactory.register(SearchBarComponent);
